/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usage_Tab_View_Model_PricingInputs */



/**
* | output |
* | --- |
* | "View model pricing" |
*
* @param {Usage_Tab_View_Model_PricingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const usage_tab_view_model_pricing = /** @type {((inputs?: Usage_Tab_View_Model_PricingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_Tab_View_Model_PricingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Modellpreise ansehen")
	return /** @type {LocalizedString} */ ("View model pricing")
});